/**
 * Created by or_p on 12/18/2016.
 */
import * as React from 'react';
import DoneIcon from '@material-ui/icons/Done';
import RemoveCircleOutlineIcon from '@material-ui/icons/RemoveCircleOutline';
import ScheduleIcon from '@material-ui/icons/Schedule';
import {xml, fileHidden, reload, duplicate, save} from '../../shared/icons';
import PublishIcon from 'material-ui/svg-icons/editor/publish';
import CachedIcon from 'material-ui/svg-icons/action/cached';
import * as _ from 'lodash';
import CustomSvgIconNew from '../../crazyEditor/components/EditorUI/BaseUI/CustomSvgIcon/CustomSvgIconNew';
import CustomSvgIconTS from '../../crazyEditor/components/EditorUI/BaseUI/CustomSvgIcon/CustomSvgIconTS';
import {SubPageProps} from "cl-layout/BasicPage";

export const SORT_FIELD = {
  MODIFIED: 0,
  TITLE: 1,
  TEMPLATE: 2,
};

export const LISTINGS_WITH_ERRORS_FILTER = 'Listings with errors';

export const LISTINGS_FILTER_FIELDS = {
  title: {
    label: 'Title',
    hint: 'Enter term that matches part of the eBay product title',
    display: 'title',
    fieldName: 'ebayTitle',
  },
  template: {
    label: 'Template name',
    hint: 'Enter a template name',
    display: 'template',
    fieldName: 'templateName',
  },
  category: {
    label: 'eBay category',
    hint: 'Enter eBay category name',
    display: 'category',
    fieldName: 'categoryName',
  },
  text: {
    label: 'Has the words',
    hint: 'Enter words found in the listing',
    display: '',
    fieldName: '',
  },
  itemIDForFilter: {
    fieldName: 'itemIDForFilter',
  },
  store: {
    label: 'eBay Store Category',
    hint: 'Enter your eBay store category name',
    display: 'store',
    fieldName: 'storeCategoryName',
  },
};

export const TEMPLATE_NAMES = {
  LEGACY_DESIGN: 'Legacy Design',
  NO_TEMPLATE: 'No Template',
  CUSTOM_DESIGN: 'Custom Design',
};

export const STATUS_FILTER_ACTIVE = 'Active';
export const STATUS_FILTER_ENDED = 'Ended';
export const STATUS_FILTER_SCHEDULED = 'Scheduled';
export const STATUS_FILTER_DRAFT = 'Draft';
export const STATUS_FILTERS = [
  STATUS_FILTER_ACTIVE,
  STATUS_FILTER_ENDED,
  STATUS_FILTER_SCHEDULED,
  STATUS_FILTER_DRAFT,
];

//TODO when removing the old listings table this should be removed as well
export const STATUS_FILTERS_PROPS = {
  [STATUS_FILTER_ACTIVE]: {
    primaryText: STATUS_FILTER_ACTIVE,
    leftIcon: <DoneIcon/>,
  },
  [STATUS_FILTER_ENDED]: {
    primaryText: STATUS_FILTER_ENDED,
    leftIcon: <RemoveCircleOutlineIcon/>,
  },
  [STATUS_FILTER_SCHEDULED]: {
    primaryText: STATUS_FILTER_SCHEDULED,
    leftIcon: <ScheduleIcon/>,
  },
  [STATUS_FILTER_DRAFT]: {
    primaryText: STATUS_FILTER_DRAFT,
    leftIcon: <CustomSvgIconNew path={fileHidden}/>,
  },
};

export const STATUS_FILTERS_TABS_PROPS: {[STATUS_FILTER_ACTIVE: string]: SubPageProps} = {
  [STATUS_FILTER_ACTIVE]: {
    title: STATUS_FILTER_ACTIVE,
    icon: <DoneIcon/>,
  },
  [STATUS_FILTER_ENDED]: {
    title: STATUS_FILTER_ENDED,
    icon: <RemoveCircleOutlineIcon/>,
  },
  [STATUS_FILTER_SCHEDULED]: {
    title: STATUS_FILTER_SCHEDULED,
    icon: <ScheduleIcon/>,
  },
  [STATUS_FILTER_DRAFT]: {
    title: STATUS_FILTER_DRAFT,
    icon: <CustomSvgIconTS path={fileHidden}/>,
  },
};


const listingActions = {
  saveDraft: {
    text: 'Save Draft',
    icon: <CustomSvgIconNew path={fileHidden}/>,
    tooltip: <div><div>SAVE DRAFT</div><div style={{lineHeight: '130%', paddingBottom: 10}}>Not ready to publish yet?<br/>Save this listing’s design as a draft and publish it later</div></div>,
  },
  showHtml: {
    text: 'Show HTML',
    icon: <CustomSvgIconNew path={xml}/>,
  },
  saveAndRevise: {
    text: 'Save & Revise',
    icon: <PublishIcon/>,
  },
  saveAndPublish: {
    text: 'Save & Publish',
    icon: <PublishIcon/>,
  },
  resetChanges: {
    text: 'Reset Changes',
    icon: <CustomSvgIconNew path={reload}/>,
  },
  duplicate: {
    text: 'Duplicate',
    icon: <CustomSvgIconNew path={duplicate}/>,
  },
  syncFromEbay: {
    text: 'Sync From eBay',
    icon: <CachedIcon/>,
  },
  saveAsTemplate: {
    text: 'Save as a Template',
    icon: <CustomSvgIconNew path={save}/>,
    tooltip: <div><div>SAVE AS A TEMPLATE</div><div style={{lineHeight: '130%', paddingBottom: 10}}>Save this listing’s design as a template to apply on other listings.</div></div>,
  },
  saveTemplate: {
    text: 'Save',
    icon: <CustomSvgIconNew path={save}/>,
    tooltip: <div><div>SAVE</div><div style={{lineHeight: '130%', paddingBottom: 10}}>Go ahead and save your progress. Listings will not be effected by this. </div></div>,
  },
};

export function getActionButtonProps(action, {iconProps = undefined, includeTooltip = false} = {}) {
  const buttonProps: any = {..._.mapKeys(listingActions[action], (value, key) => ({text: 'label'}[key] || key)), key: action};
  if (iconProps) {
    buttonProps.icon = React.cloneElement(buttonProps.icon, iconProps);
  }
  if (includeTooltip) {
    return buttonProps;
  }
  return _.omit(buttonProps, 'tooltip');
}

export function getActionMenuItemProps(action) {
  return {..._.mapKeys(listingActions[action], (value, key) => ({text: 'primaryText', icon: 'leftIcon'}[key] || key)), key: action};
}
